export default __webpack_public_path__ + "static/LeadDev_Staff_Plus_onboarding-9be7f9e0cdbff3dfa0f880015f570085.jpeg";